<div class="blogs">
    <div class="blogs__container">
        <section>
            <app-hero-section [header]="header" [hasBtn]="hasBtn" [imagePath]="imagePath" [description]="description"
                [joinChat]="joinChat">
            </app-hero-section>
        </section>
        <section>
            <div class="blogs__container-blog">
                <div class="blogs__blog-card">

                    <div class="blogs__blog-card-info">
                        <div class="blogs__blog-card-title">How to Optimize Compliance Management of Multiple NCA
                            Frameworks</div>
                            <div class="blogs__filter-result-card-Lorem">July 5 ,2023</div>
                        <img class="blogs__blog-card-img" src="../../../../assets/images/article-4.png" alt="blog-img">
                        <div class="blogs__blog-card-description">In today’s Saudi business landscape, organizations
                            often face the challenge of managing compliance across multiple National Cybersecurity
                            Authority (NCA) frameworks. The organizations in Saudi Arabia are subject to audit on
                            various NCA frameworks such as Essential Cybersecurity Controls (ECC), Organizations’ Social
                            Media Accounts Cybersecurity Controls (OSMACC), Data Cybersecurity Controls (DCC) etc.
                            throughout the year. Each framework represents a unique set of regulations, reporting
                            requirements, and deadlines, making compliance management a complex task. However, by
                            implementing effective strategies and leveraging technology, organizations can optimize
                            their compliance management processes and ensure adherence to multiple NCA frameworks in
                            Saudi Arabia. In this blog post, we will explore key steps to optimize compliance management
                            across multiple NCA frameworks. </div>
                        <button class="blogs__blog-btn-read-more" [routerLink]="['/blogs-details/4']" l10nTranslate>Read
                            more</button>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="blogs__container-all-blogs">
                <div class="blogs__filter-buttons">
                    <button class="btn-filter" (click)="blogsFilter('All')" l10nTranslate>All</button>
                    <button class="btn-filter" (click)="blogsFilter('News')" l10nTranslate>News</button>
                    <button class="btn-filter" (click)="blogsFilter('Cybersecurity')"
                        l10nTranslate>Cybersecurity</button>
                </div>
                <div class="blogs__filter-results">
                    <div class="blogs__filter-result-card" *ngFor="let blog of blogs">
                        <div class="blogs__filter-result-card-info">
                            <img [src]="blog.url" alt="blog-img">
                            <div class="blogs__filter-result-card-type">
                                <span class="blogs__filter-result-card-type-news" l10nTranslate>News</span>
                                <span class="blogs__filter-result-card-type-cybersecurity"
                                    l10nTranslate>Cybersecurity</span>
                            </div>
                            <div class="blogs__filter-result-card-details">
                                <div class="blogs__filter-result-card-title" l10nTranslate>{{blog.title}}</div>
                                <div class="blogs__filter-result-card-Lorem">July 5 ,2023</div>
                                <button class="blogs__filter-btn-read-more" (click)="blogDetailsNavigation(blog.id)"
                                    l10nTranslate>Read more</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>